import { Fragment } from 'react'
import classNames from 'classnames'

import { DragDropSortableItem } from '../../DragDrop'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowContextActions,
  TableRowLoader,
  useTableRowActions,
  useTableRowModClassName,
} from '../../Table'
import { useUploadingTableRow } from '../DocFlow.hooks'
import { isPagesOverlimit } from '../DocFlowUploading'
import { UploadingTableRowActions } from '../UploadingTableRowActions'

import { ROW_ACTIONS_CONFIG } from './DocFlowUploadingTableRow.constants'
import { renderCell } from './DocFlowUploadingTableRow.utils'

import * as styles from './DocFlowUploadingTableRow.module.css'

function DocFlowUploadingTableRow({
  Actions = UploadingTableRowActions,
  actionLeft,
  actionsColumnWidth,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  hideCheckbox,
  isLoading,
  isResizing,
  isSelected,
  isShort,
  item,
  phaseDisabled,
  resizingColumn,
  showCellBorder,
  onClickFile,
  onOpenChangeTypeModal,
  onReloadTable,
  ...restProps
}) {
  const { uploading } = item

  const {
    handleCallAction,
    handleClick,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, ...restProps }, ROW_ACTIONS_CONFIG)

  const { handleClickChangeType, handleTitleClick, mappingTypeOptions } =
    useUploadingTableRow({
      item,
      onClickFile,
      onOpenChangeTypeModal,
      onReloadTable,
    })

  const className = useTableRowModClassName({
    className: styles.DocFlowUploadingTableRow,
    isSelected,
  })

  const cellClassName = classNames(styles.DocFlowUploadingTableCell, {
    [styles.uploading]: uploading,
  })

  const qaProps = getTableRowQaProps()

  const draggingStyle = {
    backgroundColor: 'var(--color-bg-surface)',
    boxShadow: '0px 4px 18px var(--color-box-shadow-16)',
  }

  return (
    <DragDropSortableItem
      {...qaProps}
      className={className}
      draggingStyle={draggingStyle}
      id={item.id.toString()}
      sortableProps={{ disabled: item.uploading || phaseDisabled }}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          disabled={phaseDisabled || hideCheckbox || item.uploading}
          selected={isSelected}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            className: cellClassName,
            disabled: item.uploading || phaseDisabled,
            isActive: column.name === resizingColumn,
            isLoading,
            isPagesOverlimit: isPagesOverlimit(item),
            isResizing,
            isShort,
            item,
            mappingTypeOptions,
            name: column.name,
            showCellBorder,
            width: column.width,
            onClickEditType: handleClickChangeType,
            onClickFile: handleTitleClick,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item).length > 0 && !uploading && !phaseDisabled ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
      {uploading ? <TableRowLoader /> : null}
    </DragDropSortableItem>
  )
}

export default DocFlowUploadingTableRow
